import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Button, Container, Alert } from 'react-bootstrap';
import '../utils/PerfilUsuario.css';

const API_URL_USUARIO = process.env.REACT_APP_API_URL + '/usuarios'; // Usa la variable de entorno  
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

const PerfilUsuario = () => {
  const [usuario, setUsuario] = useState({
    nombre: '',
    cedula: '',
    direccion: '',
    telefono: '',
    rol: '',
    usuario: '',
    contrasenia: '', // Contraseña solo editable si se requiere cambio
  });
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    // Cargar los datos del usuario al inicio
    fetchUsuario();
  }, []);

  const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  const fetchUsuario = async () => {
    try {
      const userId = localStorage.getItem('id_usuario');
      if (!userId) {
        setErrorMessage('No se encontró información del usuario.');
        setIsLoading(false);
        return;
      }
  
      const headers = getAuthHeaders(); // Obtener los encabezados de autenticación
      const response = await axios.get(`${API_URL}/usuarios/${userId}`, { headers });
  
      setUsuario(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error('Error al cargar los datos del usuario:', error);
      setErrorMessage('No se pudieron cargar los datos del usuario.');
      setIsLoading(false);
    }
  };
  
  
  
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUsuario((prevUsuario) => ({
      ...prevUsuario,
      [name]: value
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage('');
    setErrorMessage('');
    setIsLoading(true);
  
    const updatedUser = { ...usuario };
    if (!usuario.contrasenia) {
      delete updatedUser.contrasenia; // No incluir la contraseña si no se actualiza
    }
  
    try {
      const idUsuario = localStorage.getItem('id_usuario');
      if (!idUsuario) {
        alert("No se encontró información del usuario.");
        setIsLoading(false);
        return;
      }
  
      const response = await axios.put(`${API_URL_USUARIO}/${idUsuario}`, updatedUser);
  
      if (response.status === 200) {
        setSuccessMessage('Perfil actualizado exitosamente');
        setUsuario(response.data);
      } else {
        setErrorMessage('Hubo un error al actualizar el perfil.');
      }
    } catch (error) {
      console.error('Error al actualizar el perfil:', error);
      setErrorMessage('Hubo un error al actualizar el perfil. Intenta de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };
  

  if (isLoading) {
    return <p>Cargando...</p>;
  }

  if (errorMessage) {
    return <Alert variant="danger">{errorMessage}</Alert>;
  }

  return (
    <Container className="perfil-usuario-container">
      <h2>Editar Perfil</h2>
      
      {successMessage && <Alert variant="success">{successMessage}</Alert>}
      {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="formNombre">
          <Form.Label>Nombre</Form.Label>
          <Form.Control
            type="text"
            name="nombre"
            value={usuario.nombre}
            onChange={handleInputChange}
            required
          />
        </Form.Group>

        <Form.Group controlId="formCedula">
          <Form.Label>Cédula</Form.Label>
          <Form.Control
            type="text"
            name="cedula"
            value={usuario.cedula}
            onChange={handleInputChange}
            required
          />
        </Form.Group>

        <Form.Group controlId="formDireccion">
          <Form.Label>Dirección</Form.Label>
          <Form.Control
            type="text"
            name="direccion"
            value={usuario.direccion}
            onChange={handleInputChange}
          />
        </Form.Group>

        <Form.Group controlId="formTelefono">
          <Form.Label>Teléfono</Form.Label>
          <Form.Control
            type="text"
            name="telefono"
            value={usuario.telefono}
            onChange={handleInputChange}
          />
        </Form.Group>

        <Form.Group controlId="formRol">
          <Form.Label>Rol</Form.Label>
          <Form.Control
            as="select"
            name="rol"
            value={usuario.rol}
            onChange={handleInputChange}
            required
          >
            <option value="Administrador">Administrador</option>
            <option value="Presidente">Presidente</option>
            <option value="Tesorero">Tesorero</option>
            <option value="Consumidor">Consumidor</option>
            <option value="Externo">Externo</option>
          </Form.Control>
        </Form.Group>

        <Form.Group controlId="formUsuario">
          <Form.Label>Usuario</Form.Label>
          <Form.Control
            type="text"
            name="usuario"
            value={usuario.usuario}
            onChange={handleInputChange}
            required
          />
        </Form.Group>

        <Form.Group controlId="formContrasenia">
          <Form.Label>Nueva Contraseña</Form.Label>
          <Form.Control
            type="password"
            name="contrasenia"
            value={usuario.contrasenia}
            onChange={handleInputChange}
            placeholder="Dejar en blanco si no quieres cambiarla"
          />
        </Form.Group>
        <br />

        <Button variant="primary" type="submit">
          Guardar Cambios
        </Button>
      </Form>
    </Container>
  );
};

export default PerfilUsuario;
